import React from 'react';
import styled from "styled-components";

const WorkplaceSearchHeader = (props) => {
    return <WorkplaceSearchHeaderBox>
        <ViewSwitchButtons>
            <ViewSwitchButton data-active={props.currentViewIsMap}
                              onClick={() => props.setCurrentViewIsMap(true)}>Karte</ViewSwitchButton>
            <ViewSwitchButton data-active={!props.currentViewIsMap}
                              onClick={() => props.setCurrentViewIsMap(false)}>Liste</ViewSwitchButton>
        </ViewSwitchButtons>
        Ergebnis: {(props.totalResults === undefined) ? '...' : props.totalResults} Stellen
    </WorkplaceSearchHeaderBox>
}

const WorkplaceSearchHeaderBox = styled.div`
    padding: 0 15px 15px 15px;
`;

const ViewSwitchButtons = styled.span`
    &:hover button[data-active*="true"] {
        background-color: rgb(111 19 119);
        color: white;
    }
    
    background-color: rgb(111 19 119);
    display: inline-block;
    border-radius: 20px;
    margin-right: 35px;
`;

const ViewSwitchButton = styled.button`
    &[data-active*="true"], &:hover, &:focus {
        background-color: white;
        color: rgb(0, 63, 49);
    }

    &[data-active*="true"]:hover {
        background-color: white !important;
        color: rgb(0, 63, 49) !important;
    }
    
    &[data-active*="true"]:first-child {
        border-radius: 20px;
    }


    &[data-active*="true"]:last-child {
        border-radius: 20px;
    }
    
    border-radius: 20px;
    color: white;
    background-color: transparent;
    border: none;
    outline: none;
    padding: 5px 15px;
`;


const SearchVisibleSwitchButton = styled.button`
    &[data-active*="false"] {
        color: white;
    }
    &[data-active*="true"] {
        color: gray;
    }
    
    background-color: transparent;
    border: none;
    outline: none;
    margin-right: 35px;
`;

export default WorkplaceSearchHeader;
